<ll-titulo>Administrar Establecimientos</ll-titulo>
<establecimientos-administrar [showVaciar]="showVaciar"></establecimientos-administrar>
